// generated by genversion
export var version = '3.8.5';
//# sourceMappingURL=version.js.map